import { ApplicationStore } from "Types/state";

export const errorStateSanitizer = (state: ApplicationStore) => {
    return {
        account: {
            slug: state.account.slug,
        },
        deal: state.deal,
        onlineShopper: {
            env: state.onlineShopper.env,
            hasTradeIn: state.onlineShopper.hasTradeIn,
            isAuthed: state.onlineShopper.isAuthed,
            toggledVin: state.onlineShopper.toggledVin,
        },
        tradeIn: state.tradeIn,
        vehicles: state.vehicles,
    };
};
